import React, { useState, useEffect, useRef, useCallback } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { colors, radius, s, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const DURUM_ADI = {
  bekliyor: 'sırada',
  calisiyor: 'çalışıyor',
  bitti: 'tamamlandı',
  iptal: 'iptal edildi',
  durdu: 'durduruldu',
  hata: 'hata',
}

function Field({ label, hint, children }) {
  return (
    <div style={{ marginBottom: '14px' }}>
      <label style={s.labelNormal}>{label}</label>
      {children}
      {hint && <p style={{ fontSize: '11.5px', color: colors.textSecondary, margin: '4px 0 0' }}>{hint}</p>}
    </div>
  )
}

function Sayi({ etiket, deger, alt }) {
  return (
    <div style={ui.statBox}>
      <p style={ui.statLabel}>{etiket}</p>
      <p style={ui.statValue}>{deger}</p>
      {alt && <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '4px 0 0' }}>{alt}</p>}
    </div>
  )
}

export default function SmartGeoKategori() {
  const { selectedBrand } = useBrand()
  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }
  const brandId = selectedBrand && selectedBrand.id

  const [ayar, setAyar] = useState(null)
  const [tavan, setTavan] = useState(300)
  const [ayarAcik, setAyarAcik] = useState(false)
  const [kategoriler, setKategoriler] = useState([])
  const [secili, setSecili] = useState([])
  const [acikDal, setAcikDal] = useState([])
  const [katKod, setKatKod] = useState('')
  const [katThinker, setKatThinker] = useState('')
  const [onizleme, setOnizleme] = useState(null)
  const [kosu, setKosu] = useState(null)
  const [kalemler, setKalemler] = useState([])
  const [onayliSet, setOnayliSet] = useState([])
  const [gecmis, setGecmis] = useState([])
  const [acikKalem, setAcikKalem] = useState('')
  const [gonderilen, setGonderilen] = useState('')
  const [yayin, setYayin] = useState(null)
  const yayinZaman = useRef(null)
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState(null)
  const zamanlayici = useRef(null)

  const flash = useCallback((text, ok = true) => {
    setMsg({ text, ok })
    setTimeout(() => setMsg(null), 5000)
  }, [])

  const hataMetni = e => (e.response && e.response.data && e.response.data.error) || e.message

  const kosuYukle = useCallback((runId, sessiz) => {
    if (!brandId || !runId) return
    axios.get(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${runId}`, { headers })
      .then(r => {
        setKosu(r.data)
        return axios.get(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${runId}/kalemler`, { headers })
      })
      .then(r => {
        if (!r) return
        const l = r.data.kalemler || []
        setKalemler(l)
        setOnayliSet(l.filter(x => x.onayli).map(x => x.product_id))
      })
      .catch(e => { if (!sessiz) flash(hataMetni(e), false) })
  }, [brandId]) // eslint-disable-line

  const gecmisYukle = useCallback(() => {
    if (!brandId) return
    axios.get(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosular`, { headers, params: { limit: 10 } })
      .then(r => setGecmis(r.data.kosular || []))
      .catch(() => {})
  }, [brandId]) // eslint-disable-line

  useEffect(() => {
    setAyar(null); setKategoriler([]); setSecili([]); setOnizleme(null)
    setKosu(null); setKalemler([]); setOnayliSet([]); setKatKod(''); setKatThinker('')
    if (!brandId) return
    axios.get(`${API}/admin/brands/${brandId}/smart-geo/toplu/ayar`, { headers })
      .then(r => { setAyar(r.data.ayar); setTavan(r.data.tavan || 300) })
      .catch(e => flash(hataMetni(e), false))
    axios.get(`${API}/admin/brands/${brandId}/smart-geo/toplu/kategoriler`, { headers })
      .then(r => setKategoriler(r.data.kategoriler || []))
      .catch(e => flash(hataMetni(e), false))
    gecmisYukle()
  }, [brandId]) // eslint-disable-line

  useEffect(() => {
    if (zamanlayici.current) { clearInterval(zamanlayici.current); zamanlayici.current = null }
    if (kosu && (kosu.durum === 'calisiyor' || kosu.durum === 'bekliyor')) {
      zamanlayici.current = setInterval(() => kosuYukle(kosu.id, true), 3000)
    } else if (kosu) {
      gecmisYukle()
    }
    return () => { if (zamanlayici.current) clearInterval(zamanlayici.current) }
  }, [kosu && kosu.id, kosu && kosu.durum]) // eslint-disable-line

  useEffect(() => {
    if (yayinZaman.current) { clearInterval(yayinZaman.current); yayinZaman.current = null }
    if (yayin && (yayin.durum === 'calisiyor' || yayin.durum === 'bekliyor')) {
      yayinZaman.current = setInterval(() => yayinYukle(yayin.id, true), 3000)
    } else if (yayin && kosu) {
      kosuYukle(kosu.id, true)
    }
    return () => { if (yayinZaman.current) clearInterval(yayinZaman.current) }
  }, [yayin && yayin.id, yayin && yayin.durum]) // eslint-disable-line

  function ayarKaydet() {
    setBusy(true)
    axios.put(`${API}/admin/brands/${brandId}/smart-geo/toplu/ayar`, ayar, { headers })
      .then(r => { setAyar(r.data.ayar); flash('Ayarlar kaydedildi'); setOnizleme(null) })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setBusy(false))
  }

  function kategoriSec(kod) {
    setOnizleme(null)
    setSecili(l => l.indexOf(kod) !== -1 ? l.filter(x => x !== kod) : l.concat([kod]))
  }

  function katThinkerAc(kod) {
    setKatKod(kod)
    setKatThinker('')
    axios.get(`${API}/admin/brands/${brandId}/smart-geo/toplu/kategori-thinker`, { headers, params: { kod } })
      .then(r => setKatThinker(r.data.thinker || ''))
      .catch(e => flash(hataMetni(e), false))
  }

  function katThinkerKaydet() {
    setBusy(true)
    axios.put(`${API}/admin/brands/${brandId}/smart-geo/toplu/kategori-thinker`, { kod: katKod, thinker: katThinker }, { headers })
      .then(() => {
        flash('Kategori kuralı kaydedildi')
        setKategoriler(l => l.map(x => x.category_code === katKod ? { ...x, thinker_var: katThinker.trim() ? 1 : 0 } : x))
      })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setBusy(false))
  }

  function onizlemeAl() {
    if (!secili.length) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/onizleme`, { kodlar: secili }, { headers })
      .then(r => setOnizleme(r.data))
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setBusy(false))
  }

  function kosuBaslat() {
    const adlar = kategoriler.filter(k => secili.indexOf(k.category_code) !== -1).map(k => k.category_name).join(', ')
    const n = onizleme ? onizleme.uygun : 0
    if (!window.confirm(`${n} ürün için soru-cevap üretilecek. Bu adımda hiçbir şey yayınlanmaz; üretilenleri inceleyip onayladıktan sonra taslağa yazılır. Devam edilsin mi?`)) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu`, { kodlar: secili, adlar }, { headers })
      .then(r => { flash('Üretim başladı'); setKalemler([]); setKosu({ id: r.data.runId, durum: 'calisiyor', toplam: r.data.toplam, uretilen: 0, atlanan: 0, hatali: 0, sayac: {} }); kosuYukle(r.data.runId, true) })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setBusy(false))
  }

  function kosuIptal() {
    if (!window.confirm('Üretim durdurulsun mu? Üretilenler korunur.')) return
    axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${kosu.id}/iptal`, {}, { headers })
      .then(() => flash('Durdurma istendi, sıradaki ürün bitince duracak'))
      .catch(e => flash(hataMetni(e), false))
  }

  function kosuDevam() {
    setBusy(true)
    axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${kosu.id}/devam`, {}, { headers })
      .then(() => { flash('Üretim kaldığı yerden devam ediyor'); setKosu(k => ({ ...k, durum: 'calisiyor' })) })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setBusy(false))
  }

  function onayDegistir(pid) {
    setOnayliSet(l => l.indexOf(pid) !== -1 ? l.filter(x => x !== pid) : l.concat([pid]))
  }

  function topluSec(tur) {
    const u = kalemler.filter(k => k.durum === 'uretildi')
    if (tur === 'hepsi') setOnayliSet(u.map(k => k.product_id))
    else if (tur === 'temiz') setOnayliSet(u.filter(k => !(k.uyarilar || []).length).map(k => k.product_id))
    else setOnayliSet([])
  }

  function secilenleriKaydet() {
    const u = kalemler.filter(k => k.durum === 'uretildi').map(k => k.product_id)
    const acilacak = onayliSet.filter(x => u.indexOf(x) !== -1)
    if (!acilacak.length) { flash('Önce ürün seçin', false); return }
    if (!window.confirm(`${acilacak.length} ürünün soru-cevabı taslak olarak kaydedilecek. Bu işlem hiçbir şeyi yayınlamaz; yayınlamak için ürünün yanındaki “Ürüne gönder” düğmesini kullanın. Devam edilsin mi?`)) return
    const kapanacak = u.filter(x => onayliSet.indexOf(x) === -1)
    setBusy(true)
    const istekler = [axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${kosu.id}/onay`, { urunler: acilacak, onayli: true }, { headers })]
    if (kapanacak.length) istekler.push(axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${kosu.id}/onay`, { urunler: kapanacak, onayli: false }, { headers }))
    Promise.all(istekler)
      .then(() => axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${kosu.id}/taslak`, { uzerineYaz: true }, { headers }))
      .then(r => { flash(r.data.yazilan + ' ürünün soru-cevabı taslağa kaydedildi'); kosuYukle(kosu.id, true) })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setBusy(false))
  }

  const yayinYukle = useCallback((yayinId, sessiz) => {
    if (!brandId || !yayinId) return
    axios.get(`${API}/admin/brands/${brandId}/smart-geo/toplu/yayin/${yayinId}`, { headers })
      .then(r => setYayin(r.data))
      .catch(e => { if (!sessiz) flash(hataMetni(e), false) })
  }, [brandId]) // eslint-disable-line

  function yayinlaSecilenleri() {
    const u = kalemler.filter(k => k.durum === 'uretildi').map(k => k.product_id)
    const secilen = onayliSet.filter(x => u.indexOf(x) !== -1)
    if (!secilen.length) { flash('Önce ürün seçin', false); return }
    const yayindaOlan = kalemler.filter(k => secilen.indexOf(k.product_id) !== -1 && k.yayinda).length
    const metin = `${secilen.length} ürünün soru-cevap bloğu ürün açıklamalarının sonuna eklenecek ve CANLIDA görünecek.`
      + (yayindaOlan ? ` Bunların ${yayindaOlan} tanesi zaten yayında, içerikleri değiştirilecek.` : '')
      + ' Devam edilsin mi?'
    if (!window.confirm(metin)) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${kosu.id}/yayin`, { urunler: secilen }, { headers })
      .then(r => { flash('Yayın başladı'); setYayin({ id: r.data.yayinId, durum: 'calisiyor', toplam: r.data.toplam, yayinlanan: 0, hatali: 0, sayac: {}, hatalar: [] }); yayinYukle(r.data.yayinId, true) })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setBusy(false))
  }

  function yayinIptal() {
    if (!window.confirm('Yayın durdurulsun mu? Yayınlananlar canlıda kalır.')) return
    axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/yayin/${yayin.id}/iptal`, {}, { headers })
      .then(() => flash('Durdurma istendi, sıradaki ürün bitince duracak'))
      .catch(e => flash(hataMetni(e), false))
  }

  function yayinDevam() {
    setBusy(true)
    axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/yayin/${yayin.id}/devam`, {}, { headers })
      .then(() => { flash('Yayın kaldığı yerden devam ediyor'); setYayin(y => ({ ...y, durum: 'calisiyor' })) })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setBusy(false))
  }

  function urunGonder(k) {
    const soru = k.yayinda
      ? `“${k.product_name}” ürününde zaten yayında olan soru-cevaplar bu yenileriyle DEĞİŞTİRİLECEK ve canlıda görünecek. Devam edilsin mi?`
      : `“${k.product_name}” ürününün açıklamasının sonuna ${(k.faq || []).length} soruluk blok eklenecek ve canlıda görünecek. Devam edilsin mi?`
    if (!window.confirm(soru)) return
    setGonderilen(k.product_id)
    axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${kosu.id}/urun/${k.product_id}/gonder`, {}, { headers })
      .then(r => { flash(`${r.data.soru} soru ürüne gönderildi — ${k.product_name}`); kosuYukle(kosu.id, true) })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setGonderilen(''))
  }

  function urunGeriAl(k) {
    if (!window.confirm(`“${k.product_name}” ürününden soru-cevap bloğu kaldırılacak, açıklama eski haline dönecek. Devam edilsin mi?`)) return
    setGonderilen(k.product_id)
    axios.post(`${API}/admin/brands/${brandId}/smart-geo/toplu/kosu/${kosu.id}/urun/${k.product_id}/geri-al`, {}, { headers })
      .then(() => { flash('Blok kaldırıldı — ' + k.product_name); kosuYukle(kosu.id, true) })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setGonderilen(''))
  }

  if (!selectedBrand) return <div style={ui.notice}>Önce bir marka seçin.</div>

  const cocukHarita = {}
  kategoriler.forEach(k => {
    const p = k.parent_code || ''
    if (!cocukHarita[p]) cocukHarita[p] = []
    cocukHarita[p].push(k)
  })

  const uretilenler = kalemler.filter(k => k.durum === 'uretildi')
  const atlananlar = kalemler.filter(k => k.durum === 'atlandi')
  const hatalilar = kalemler.filter(k => k.durum === 'hata')
  const ilerleme = kosu && kosu.toplam ? Math.round(((kosu.uretilen + kosu.atlanan + kosu.hatali) / kosu.toplam) * 100) : 0
  const calisiyor = kosu && (kosu.durum === 'calisiyor' || kosu.durum === 'bekliyor')
  const yayindaAdet = kalemler.filter(k => k.yayinda).length
  const yayinKosuyor = !!(yayin && (yayin.durum === 'calisiyor' || yayin.durum === 'bekliyor'))
  const yayinIlerleme = yayin && yayin.toplam ? Math.round(((yayin.yayinlanan + yayin.hatali) / yayin.toplam) * 100) : 0

  function dalCiz(kod, derinlik) {
    if (derinlik > 8) return null
    const liste = cocukHarita[kod] || []
    return liste.map(k => {
      const cocuk = (cocukHarita[k.category_code] || []).length
      const acik = acikDal.indexOf(k.category_code) !== -1
      const isaretli = secili.indexOf(k.category_code) !== -1
      return (
        <div key={k.category_code}>
          <div style={{
            display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px',
            paddingLeft: (8 + derinlik * 18) + 'px', borderRadius: radius.sm,
            background: isaretli ? colors.bgSelected : 'transparent',
          }}>
            {cocuk > 0 ? (
              <button style={{ ...ui.btnQuiet, padding: '2px 6px', minWidth: '24px' }}
                onClick={() => setAcikDal(l => acik ? l.filter(x => x !== k.category_code) : l.concat([k.category_code]))}>
                {acik ? '–' : '+'}
              </button>
            ) : <span style={{ display: 'inline-block', width: '24px' }} />}
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0, cursor: 'pointer' }}>
              <input type="checkbox" checked={isaretli} onChange={() => kategoriSec(k.category_code)} disabled={calisiyor} />
              <span style={{ fontSize: '13px', color: colors.textPrimary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {k.category_name}
              </span>
            </label>
            {k.thinker_var > 0 && <span style={ui.chipStrong}>kural</span>}
            <span style={{ fontSize: '11.5px', color: colors.textMuted, fontVariantNumeric: 'tabular-nums', minWidth: '52px', textAlign: 'right' }}>
              {k.urun} ürün
            </span>
            <button style={{ ...ui.btnSm, padding: '3px 8px' }} onClick={() => katThinkerAc(k.category_code)}>Kural</button>
          </div>
          {acik && dalCiz(k.category_code, derinlik + 1)}
        </div>
      )
    })
  }

  return (
    <div>
      {msg && <div style={{ ...(msg.ok ? s.alertSuccess : s.alertDanger), marginBottom: '16px' }}>{msg.text}</div>}

      <div style={{ ...ui.notice, marginBottom: '16px' }}>
        Bu ekran yalnızca <b>üretir</b>. Üretilen soru-cevaplar siz inceleyip onaylayana kadar hiçbir yere yazılmaz,
        onaydan sonra da yalnızca taslak olarak kaydedilir. Ürün sayfasına yayınlama ayrı bir adımdır.
      </div>

      <div style={{ ...s.card, marginBottom: '16px' }}>
        <div style={{ ...s.flexBetween, flexWrap: 'wrap', gap: '8px' }}>
          <div>
            <h3 style={{ ...s.sectionTitle, margin: 0 }}>Marka kuralları ve üretim ayarları</h3>
            <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '2px 0 0' }}>
              Buradaki kural bu markanın tüm kategorilerinde geçerli olur.
            </p>
          </div>
          <button style={ui.btnQuiet} onClick={() => setAyarAcik(v => !v)}>{ayarAcik ? 'Gizle' : 'Düzenle'}</button>
        </div>

        {ayarAcik && ayar && (
          <div style={{ marginTop: '14px' }}>
            <Field label="Marka kuralı (thinker)" hint="Yapay zekaya bu markada uyması gereken kuralları yazın. Örnek: aynı ürünün farklı varyantlarına ve aynı ürün grubunun kendi içindeki küçük farklılıklarına istinaden soruları farklılaştır.">
              <textarea style={{ ...s.input, minHeight: '92px', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.55 }}
                value={ayar.thinker || ''} onChange={e => setAyar(a => ({ ...a, thinker: e.target.value }))} />
            </Field>

            <div className="sx-grid-panel" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: '14px' }}>
              <Field label="Ürün başına soru sayısı">
                <select style={s.select} value={ayar.soru_adet} onChange={e => setAyar(a => ({ ...a, soru_adet: parseInt(e.target.value) }))}>
                  {[3, 4, 5, 6, 7, 8].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </Field>
              <Field label="Benzerlik eşiği" hint="Aynı kategoride bu orandan fazla benzeyen sorular üreten ürün atlanır. Düşürmek daha az ama daha özgün içerik üretir.">
                <select style={s.select} value={String(ayar.benzerlik_esigi)} onChange={e => setAyar(a => ({ ...a, benzerlik_esigi: parseFloat(e.target.value) }))}>
                  {['0.3', '0.35', '0.4', '0.45', '0.5', '0.55', '0.6'].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </Field>
              <Field label="En az kaynak uzunluğu" hint="Açıklaması ve özellikleri bu karakter sayısının altında kalan ürünler atlanır.">
                <input style={s.input} type="number" value={ayar.kaynak_min_uzunluk}
                  onChange={e => setAyar(a => ({ ...a, kaynak_min_uzunluk: parseInt(e.target.value) || 0 }))} />
              </Field>
            </div>

            <div style={{ borderTop: `1px solid ${colors.borderLight}`, margin: '6px 0 14px', paddingTop: '14px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', cursor: 'pointer' }}>
                <input type="checkbox" checked={ayar.yorum_kullan !== false}
                  onChange={e => setAyar(a => ({ ...a, yorum_kullan: e.target.checked }))} />
                <span style={{ fontSize: '13px' }}>Müşteri yorumlarından yararlan</span>
              </label>
              <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '0 0 12px' }}>
                Yorumlar yapay zekaya <b>deneyim</b> olarak verilir, ürün özelliği olarak değil. Cevaplarda
                “müşterilerimiz belirtiyor” biçiminde geçer; teknik iddialar yalnızca ürünün kendi verisinden yazılır.
              </p>
              {ayar.yorum_kullan !== false && (
                <div className="sx-grid-panel" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '14px' }}>
                  <Field label="Ürün başına yorum sayısı">
                    <input style={s.input} type="number" value={ayar.yorum_adet}
                      onChange={e => setAyar(a => ({ ...a, yorum_adet: parseInt(e.target.value) || 0 }))} />
                  </Field>
                  <Field label="En düşük puan">
                    <select style={s.select} value={ayar.yorum_min_puan} onChange={e => setAyar(a => ({ ...a, yorum_min_puan: parseInt(e.target.value) }))}>
                      {[1, 2, 3, 4, 5].map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                  </Field>
                  <Field label="En az yorum uzunluğu" hint="Kısa ve bilgi taşımayan yorumları eler.">
                    <input style={s.input} type="number" value={ayar.yorum_min_uzunluk}
                      onChange={e => setAyar(a => ({ ...a, yorum_min_uzunluk: parseInt(e.target.value) || 0 }))} />
                  </Field>
                </div>
              )}
            </div>

            <button style={s.btnSecondary} onClick={ayarKaydet} disabled={busy}>Ayarları kaydet</button>
          </div>
        )}
      </div>

      <div style={{ ...s.card, marginBottom: '16px' }}>
        <div style={{ ...s.flexBetween, marginBottom: '10px', flexWrap: 'wrap', gap: '8px' }}>
          <h3 style={{ ...s.sectionTitle, margin: 0 }}>Kategori seçin</h3>
          <span style={{ fontSize: '11.5px', color: colors.textMuted }}>
            {secili.length
              ? secili.length + ' kategori seçili · bir seferde en fazla ' + tavan + ' ürün'
              : 'Seçtiğiniz kategorinin alt kategorileri de dahil edilir'}
          </span>
        </div>

        {kategoriler.length === 0
          ? <p style={ui.emptyText}>Bu markada kategori bulunamadı.</p>
          : (
            <div style={{ maxHeight: '360px', overflowY: 'auto', border: `1px solid ${colors.borderLight}`, borderRadius: radius.md, padding: '6px' }}>
              {dalCiz('', 0)}
            </div>
          )}

        {katKod && (
          <div style={{ ...s.cardFlat, padding: '14px', marginTop: '12px' }}>
            <Field
              label={'Kategori kuralı — ' + ((kategoriler.find(x => x.category_code === katKod) || {}).category_name || katKod)}
              hint="Yalnızca bu kategoride geçerli ek kural. Marka kuralının üzerine eklenir, onu silmez.">
              <textarea style={{ ...s.input, minHeight: '76px', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.55 }}
                value={katThinker} onChange={e => setKatThinker(e.target.value)} />
            </Field>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <button style={s.btnSecondary} onClick={katThinkerKaydet} disabled={busy}>Kategori kuralını kaydet</button>
              <button style={ui.btnQuiet} onClick={() => { setKatKod(''); setKatThinker('') }}>Kapat</button>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center', marginTop: '14px' }}>
          <button style={s.btnSecondary} onClick={onizlemeAl} disabled={busy || !secili.length || calisiyor}>Kaç ürün etkilenecek?</button>
          {secili.length > 0 && <button style={ui.btnQuiet} onClick={() => { setSecili([]); setOnizleme(null) }}>Seçimi temizle</button>}
        </div>
      </div>

      {onizleme && (
        <div style={{ ...s.card, marginBottom: '16px' }}>
          <h3 style={{ ...s.sectionTitle, marginBottom: '12px' }}>Üretim öncesi durum</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px', marginBottom: '14px' }}>
            <Sayi etiket="Üretilecek ürün" deger={onizleme.uygun} alt={onizleme.kaynak_yetersiz ? onizleme.kaynak_yetersiz + ' ürün kaynak yetersiz, atlanacak' : 'tümünün kaynağı yeterli'} />
            <Sayi etiket="Varyant kümesi" deger={onizleme.coklu_kume} alt={onizleme.kumedeki_urun + ' ürün bir kümede'} />
            <Sayi etiket="Yorumu olan ürün" deger={onizleme.yorumlu_urun} alt={onizleme.yorum_toplam + ' yorum havuzda'} />
            <Sayi etiket="Zaten içeriği olan" deger={onizleme.geo_var} alt="bunlar yeniden üretilir" />
          </div>

          {onizleme.coklu_kume > 0 && (
            <p style={{ fontSize: '12px', color: colors.textSecondary, margin: '0 0 10px' }}>
              Seçtiğiniz kategoride <b>{onizleme.kumedeki_urun} ürün</b> birbirinin varyantı görünüyor. Bunlarda
              sorular birbirine çok benzerse ürün otomatik atlanır; yakın kopya içerik yayınlanmaz.
            </p>
          )}
          {onizleme.yorum_bayatlik_gun != null && onizleme.yorum_bayatlik_gun > 45 && (
            <p style={{ ...s.badgeWarning, display: 'inline-block', fontSize: '11.5px', marginBottom: '10px' }}>
              En yeni yorum {onizleme.yorum_bayatlik_gun} gün önceye ait
            </p>
          )}
          {onizleme.tavan_asildi && (
            <p style={{ ...s.badgeWarning, display: 'inline-block', fontSize: '11.5px', marginBottom: '10px' }}>
              Bir seferde en fazla {onizleme.tavan} ürün işlenebilir. Daha az kategori seçin.
            </p>
          )}

          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
            <button style={s.btnPrimary} onClick={kosuBaslat} disabled={busy || !onizleme.uygun || onizleme.tavan_asildi || calisiyor}>
              Üretimi başlat
            </button>
            <span style={{ fontSize: '11.5px', color: colors.textMuted }}>
              Yaklaşık {Math.max(1, Math.round(onizleme.uygun * 10 / 60))} dakika sürer · hiçbir şey yayınlanmaz
            </span>
          </div>
        </div>
      )}

      {kosu && (
        <div style={{ ...s.card, marginBottom: '16px' }}>
          <div style={{ ...s.flexBetween, marginBottom: '10px', flexWrap: 'wrap', gap: '8px' }}>
            <div>
              <h3 style={{ ...s.sectionTitle, margin: 0 }}>
                Üretim {kosu.id} — {DURUM_ADI[kosu.durum] || kosu.durum}
              </h3>
              {kosu.kategori_adlari && <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '2px 0 0' }}>{kosu.kategori_adlari}</p>}
            </div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {calisiyor && <button style={ui.btnDangerQuiet} onClick={kosuIptal}>Durdur</button>}
              {!calisiyor && (kosu.sayac && kosu.sayac.bekliyor > 0) && (
                <button style={s.btnSecondary} onClick={kosuDevam} disabled={busy}>Kaldığı yerden devam et</button>
              )}
              <button style={ui.btnQuiet} onClick={() => kosuYukle(kosu.id)}>Yenile</button>
            </div>
          </div>

          <div style={{ ...ui.meter, marginBottom: '10px' }}><div style={ui.meterFill(ilerleme)} /></div>

          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '12px', color: colors.textSecondary, marginBottom: '4px' }}>
            <span>{kosu.uretilen} üretildi</span>
            <span>{kosu.atlanan} atlandı</span>
            {kosu.hatali > 0 && <span style={{ color: colors.dangerText }}>{kosu.hatali} hata</span>}
            <span>toplam {kosu.toplam}</span>
            {kosu.benzerlik_ort != null && <span>ortalama benzerlik {Number(kosu.benzerlik_ort).toFixed(2)}</span>}
          </div>
          {kosu.hata && <p style={{ ...s.badgeWarning, display: 'inline-block', fontSize: '11.5px', marginTop: '8px' }}>{kosu.hata}</p>}
        </div>
      )}

      {yayin && (
        <div style={{ ...s.card, marginBottom: '16px' }}>
          <div style={{ ...s.flexBetween, marginBottom: '10px', flexWrap: 'wrap', gap: '8px' }}>
            <div>
              <h3 style={{ ...s.sectionTitle, margin: 0 }}>
                Yayın {yayin.id} — {DURUM_ADI[yayin.durum] || yayin.durum}
              </h3>
              <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '2px 0 0' }}>
                Bu adım ürünleri <b>canlıya</b> yazar.
              </p>
            </div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {yayinKosuyor && <button style={ui.btnDangerQuiet} onClick={yayinIptal}>Durdur</button>}
              {!yayinKosuyor && (yayin.sayac && yayin.sayac.bekliyor > 0) && (
                <button style={s.btnSecondary} onClick={yayinDevam} disabled={busy}>Kaldığı yerden devam et</button>
              )}
              <button style={ui.btnQuiet} onClick={() => yayinYukle(yayin.id)}>Yenile</button>
              {!yayinKosuyor && <button style={ui.btnQuiet} onClick={() => setYayin(null)}>Kapat</button>}
            </div>
          </div>

          <div style={{ ...ui.meter, marginBottom: '10px' }}><div style={ui.meterFill(yayinIlerleme)} /></div>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '12px', color: colors.textSecondary }}>
            <span style={{ color: colors.successText }}>{yayin.yayinlanan} yayınlandı</span>
            {yayin.hatali > 0 && <span style={{ color: colors.dangerText }}>{yayin.hatali} hata</span>}
            <span>toplam {yayin.toplam}</span>
          </div>
          {yayin.hata && <p style={{ ...s.badgeWarning, display: 'inline-block', fontSize: '11.5px', marginTop: '8px' }}>{yayin.hata}</p>}
          {(yayin.hatalar || []).length > 0 && (
            <div style={{ marginTop: '12px', borderTop: `1px solid ${colors.borderLight}`, paddingTop: '10px' }}>
              <div style={{ fontSize: '12.5px', fontWeight: 600, color: colors.dangerText, marginBottom: '6px' }}>
                Yayınlanamayan ürünler
              </div>
              {yayin.hatalar.map(h => (
                <div key={h.product_id} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', padding: '4px 0', fontSize: '12px' }}>
                  <span style={{ flex: '1 1 200px', minWidth: 0, color: colors.textSecondary }}>{h.product_name}</span>
                  <span style={{ fontSize: '11.5px', color: colors.textMuted, flex: '1 1 240px', minWidth: 0 }}>{h.yayin_sebep}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {kalemler.length > 0 && (
        <div style={{ ...s.card, marginBottom: '16px' }}>
          <div style={{ ...s.flexBetween, marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
            <h3 style={{ ...s.sectionTitle, margin: 0 }}>Üretilenleri inceleyin</h3>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <button style={ui.btnSm} onClick={() => topluSec('temiz')}>Uyarısızları seç</button>
              <button style={ui.btnSm} onClick={() => topluSec('hepsi')}>Hepsini seç</button>
              <button style={ui.btnQuiet} onClick={() => topluSec('hic')}>Seçimi kaldır</button>
            </div>
          </div>

          {uretilenler.map(k => {
            const acik = acikKalem === k.product_id
            const uyari = (k.uyarilar || []).length
            const kay = k.kaynaklar || {}
            return (
              <div key={k.product_id} style={{ ...s.cardFlat, padding: '12px 14px', marginBottom: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', flexWrap: 'wrap' }}>
                  <input type="checkbox" style={{ marginTop: '3px' }} checked={onayliSet.indexOf(k.product_id) !== -1}
                    onChange={() => onayDegistir(k.product_id)} />
                  <div style={{ flex: '1 1 220px', minWidth: 0 }}>
                    <div style={{ fontSize: '13px', fontWeight: 600, color: colors.textPrimary }}>{k.product_name}</div>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '5px', alignItems: 'center' }}>
                      <span style={{ fontSize: '11.5px', color: colors.textMuted }}>{(k.faq || []).length} soru</span>
                      {kay.yorum_adet > 0 && <span style={ui.chip}>{kay.yorum_adet} yorum kullanıldı</span>}
                      {kay.ozellik > 0 && <span style={ui.chip}>{kay.ozellik} özellik</span>}
                      {kay.ayirt_edici && <span style={ui.chipStrong}>ayırt edici: {kay.ayirt_edici}</span>}
                      {k.benzerlik != null && <span style={{ fontSize: '11.5px', color: colors.textMuted }}>benzerlik {Number(k.benzerlik).toFixed(2)}</span>}
                      {uyari > 0 && <span style={{ ...s.badgeWarning, fontSize: '11px' }}>{uyari} uyarı</span>}
                      {k.yayinda && <span style={{ ...s.badgeSuccess, fontSize: '11px' }}>yayında</span>}
                      {!k.yayinda && k.onayli && <span style={ui.chip}>taslak kaydedildi</span>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <button style={ui.btnSm} onClick={() => setAcikKalem(acik ? '' : k.product_id)}>{acik ? 'Kapat' : 'Soruları gör'}</button>
                    {k.yayinda && (
                      <button style={ui.btnDangerQuiet} onClick={() => urunGeriAl(k)}
                        disabled={!!gonderilen || calisiyor}>Kaldır</button>
                    )}
                    <button style={k.yayinda ? ui.btnSm : s.btnPrimary} onClick={() => urunGonder(k)}
                      disabled={!!gonderilen || calisiyor}>
                      {gonderilen === k.product_id ? 'Gönderiliyor…' : (k.yayinda ? 'Yeniden gönder' : 'Ürüne gönder')}
                    </button>
                  </div>
                </div>

                {acik && (
                  <div style={{ marginTop: '12px', borderTop: `1px solid ${colors.borderLight}`, paddingTop: '12px' }}>
                    {(k.faq || []).map((f, i) => (
                      <div key={i} style={{ marginBottom: '12px' }}>
                        <div style={{ fontSize: '13px', fontWeight: 600, color: colors.textPrimary, marginBottom: '3px' }}>{f.question}</div>
                        <div style={{ fontSize: '12.5px', color: colors.textSecondary, lineHeight: 1.6 }}>{f.answer}</div>
                      </div>
                    ))}
                    {uyari > 0 && (
                      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        {(k.uyarilar || []).map((u, i) => <span key={i} style={{ ...s.badgeWarning, fontSize: '11px' }}>{u}</span>)}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
          })}

          {atlananlar.length > 0 && (
            <div style={{ marginTop: '14px' }}>
              <h4 style={{ fontSize: '13px', fontWeight: 600, color: colors.textSecondary, margin: '0 0 8px' }}>
                Atlanan {atlananlar.length} ürün
              </h4>
              <p style={{ ...ui.emptyText, margin: '0 0 8px' }}>
                Bu ürünlerde üretilen sorular aynı kategorideki başka bir ürünün sorularına çok benzediği için
                yayına uygun bulunmadı. Benzerlik eşiğini yükseltirseniz bir kısmı geçebilir, ancak içerik birbirine yaklaşır.
              </p>
              {atlananlar.map(k => (
                <div key={k.product_id} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center', padding: '5px 0', fontSize: '12px', color: colors.textSecondary }}>
                  <span style={{ flex: '1 1 200px', minWidth: 0 }}>{k.product_name}</span>
                  <span style={{ fontSize: '11.5px', color: colors.textMuted }}>{k.sebep}</span>
                </div>
              ))}
            </div>
          )}

          {hatalilar.length > 0 && (
            <div style={{ marginTop: '14px' }}>
              <h4 style={{ fontSize: '13px', fontWeight: 600, color: colors.dangerText, margin: '0 0 8px' }}>
                Hata alan {hatalilar.length} ürün
              </h4>
              {hatalilar.map(k => (
                <div key={k.product_id} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', padding: '5px 0', fontSize: '12px', color: colors.textSecondary }}>
                  <span style={{ flex: '1 1 200px', minWidth: 0 }}>{k.product_name}</span>
                  <span style={{ fontSize: '11.5px', color: colors.dangerText }}>{k.sebep}</span>
                </div>
              ))}
            </div>
          )}

          <div style={{ borderTop: `1px solid ${colors.border}`, marginTop: '16px', paddingTop: '14px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
            <button style={s.btnPrimary} onClick={yayinlaSecilenleri} disabled={busy || calisiyor || yayinKosuyor || !onayliSet.length}>
              Seçilenleri yayınla ({onayliSet.length})
            </button>
            <button style={s.btnSecondary} onClick={secilenleriKaydet} disabled={busy || calisiyor || yayinKosuyor || !onayliSet.length}>
              Taslağa kaydet
            </button>
            <span style={{ fontSize: '11.5px', color: colors.textMuted, flex: '1 1 260px', minWidth: 0 }}>
              Taslak kaydetmek <b>hiçbir şeyi yayınlamaz</b>; içeriği sonra düzenlemek için saklar.
              Yayınlamak için ürünün yanındaki <b>Ürüne gönder</b> düğmesini kullanın.
              {yayindaAdet > 0 && ' Şu an ' + yayindaAdet + ' ürün yayında.'}
            </span>
          </div>
        </div>
      )}

      {gecmis.length > 0 && (
        <div style={s.card}>
          <h3 style={{ ...s.sectionTitle, marginBottom: '12px' }}>Geçmiş üretimler</h3>
          {gecmis.map(g => (
            <div key={g.id} style={{
              display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center',
              padding: '9px 0', borderBottom: `1px solid ${colors.borderLight}`, fontSize: '12.5px',
            }}>
              <span style={{ fontVariantNumeric: 'tabular-nums', color: colors.textMuted, minWidth: '34px' }}>#{g.id}</span>
              <span style={{ flex: '1 1 180px', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {g.kategori_adlari || '(kategori adı yok)'}
              </span>
              <span style={ui.chip}>{DURUM_ADI[g.durum] || g.durum}</span>
              <span style={{ color: colors.textSecondary }}>{g.uretilen}/{g.toplam} üretildi</span>
              {g.onayli > 0 && <span style={{ color: colors.textSecondary }}>{g.onayli} onaylı</span>}
              <span style={{ color: colors.textMuted, fontSize: '11.5px' }}>{new Date(g.basladi).toLocaleString('tr-TR')}</span>
              <button style={ui.btnSm} onClick={() => { setKosu(null); setKalemler([]); kosuYukle(g.id) }}>Aç</button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
